import { render } from "./DatasetCheckoutSuccess.vue?vue&type=template&id=3d2d725c"
import script from "./DatasetCheckoutSuccess.vue?vue&type=script&lang=js"
export * from "./DatasetCheckoutSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__